import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import ShopTypeNewEditForm from './ShopTypeNewEditForm';
// ----------------------------------------------------------------------

export default function ShopTypeCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={!isEdit ? `${translate('ShopType.AddTitle')}` : `${translate('ShopType.UpdateTitle')}`}
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('ShopType.CreateShopType')}`
              : `${translate('ShopType.EditShopType')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('ShopType.ShopTypeList')}`,
              href: PATH_DASHBOARD.ShopType.list,
            },
            {
              name: !isEdit ? `${translate('ShopType.New')}` : `${translate('ShopType.Update')}`,
            },
          ]}
        />
        <ShopTypeNewEditForm />
      </Container>
    </Page>
  );
}
